<template>
  <auto-menu-layout :loading="loading">
    <div data-testid="suggestions-overview">
      <h2 class="mb-2">{{ $t('auto_t.suggestions_overview') }}</h2>
      <p class="mb-4 text-medium-emphasis">{{ $t('auto_t.suggestions_overview_hint') }}</p>

      <div class="mb-4 d-flex align-center ga-2">
        <v-btn
          color="error"
          variant="outlined"
          data-testid="suggestions-clear-all"
          :disabled="loading || rows.length === 0"
          @click="confirmClearAll = true"
        >
          {{ $t('auto_t.suggestions_clear_all') }}
        </v-btn>
        <v-btn
          variant="text"
          data-testid="suggestions-overview-refresh"
          :disabled="loading"
          @click="load"
        >
          {{ $t('auto_t.btn_refresh') }}
        </v-btn>
      </div>

      <v-alert
        v-if="!loading && rows.length === 0"
        type="info"
        variant="tonal"
        class="mb-4"
        data-testid="suggestions-overview-empty"
      >
        {{ $t('auto_t.suggestions_overview_empty') }}
      </v-alert>

      <v-table v-else density="comfortable" data-testid="suggestions-overview-table">
        <thead>
          <tr>
            <th>{{ $t('auto_t.suggestions_col_model') }}</th>
            <th>{{ $t('auto_t.suggestions_col_count') }}</th>
            <th>{{ $t('auto_t.suggestions_col_assets') }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="row in rows"
            :key="rowKey(row)"
            :data-testid="'suggestions-overview-row-' + rowKey(row)"
          >
            <td>{{ row.model_name }}</td>
            <td data-testid="suggestions-overview-count">{{ row.count }}</td>
            <td>{{ row.asset_count }}</td>
            <td class="text-right">
              <v-btn
                color="error"
                size="small"
                variant="text"
                :data-testid="'suggestions-clear-model-' + rowKey(row)"
                :disabled="loading"
                @click="askClearModel(row)"
              >
                {{ $t('auto_t.suggestions_clear_model') }}
              </v-btn>
            </td>
          </tr>
        </tbody>
      </v-table>

      <v-dialog v-model="confirmClearAll" max-width="480">
        <v-card>
          <v-card-title>{{ $t('auto_t.suggestions_clear_all') }}</v-card-title>
          <v-card-text>{{ $t('auto_t.suggestions_clear_all_confirm') }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn variant="text" @click="confirmClearAll = false">Cancel</v-btn>
            <v-btn color="error" data-testid="suggestions-clear-all-confirm" @click="clearAll">
              {{ $t('auto_t.suggestions_clear_all') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="confirmClearModel" max-width="480">
        <v-card>
          <v-card-title>{{ $t('auto_t.suggestions_clear_model') }}</v-card-title>
          <v-card-text>
            {{ $t('auto_t.suggestions_clear_model_confirm', { model: pendingModelName }) }}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn variant="text" @click="confirmClearModel = false">Cancel</v-btn>
            <v-btn color="error" data-testid="suggestions-clear-model-confirm" @click="clearModel">
              {{ $t('auto_t.suggestions_clear_model') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </auto-menu-layout>
</template>

<script>
import AutoMenuLayout from "@/components/layout/AutoMenuLayout";

export default {
  name: "AutoSuggestionsOverview",
  components: { AutoMenuLayout },
  data() {
    return {
      loading: false,
      rows: [],
      confirmClearAll: false,
      confirmClearModel: false,
      pendingModelId: undefined,
      pendingModelName: '',
    };
  },
  methods: {
    rowKey(row) {
      return row.model_id == null ? 'none' : String(row.model_id);
    },
    async load() {
      this.loading = true;
      try {
        const data = await this.$api.suggestions.overview();
        this.rows = Array.isArray(data) ? data : [];
      } catch (e) {
        this.rows = [];
        await this.$store.dispatch('snackbars/add_failed_snack', this.$t('auto_t.suggestions_overview_error'));
      } finally {
        this.loading = false;
      }
    },
    askClearModel(row) {
      this.pendingModelId = row.model_id;
      this.pendingModelName = row.model_name;
      this.confirmClearModel = true;
    },
    async clearModel() {
      this.confirmClearModel = false;
      this.loading = true;
      try {
        await this.$api.suggestions.clear_by_model(this.pendingModelId);
        await this.$store.dispatch('snackbars/add_success_snack', this.$t('auto_t.suggestions_cleared'));
        await this.load();
      } catch (e) {
        this.loading = false;
        await this.$store.dispatch('snackbars/add_failed_snack', this.$t('auto_t.suggestions_overview_error'));
      }
    },
    async clearAll() {
      this.confirmClearAll = false;
      this.loading = true;
      try {
        await this.$api.suggestions.clear_all();
        await this.$store.dispatch('snackbars/add_success_snack', this.$t('auto_t.suggestions_cleared'));
        await this.load();
      } catch (e) {
        this.loading = false;
        await this.$store.dispatch('snackbars/add_failed_snack', this.$t('auto_t.suggestions_overview_error'));
      }
    },
  },
  mounted() {
    this.load();
  },
};
</script>
